
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './AdminLogin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { adminLogin, isAdmin } = useAuth(); // Use adminLogin instead of login
  const navigate = useNavigate();

  // If already logged in as admin, redirect to admin panel
  React.useEffect(() => {
    if (isAdmin) {
      navigate('/admin');
    }
  }, [isAdmin, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      if (!email || !password) {
        setError('Please fill in all fields');
        setIsLoading(false);
        return;
      }

      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      const result = adminLogin(email, password);
      
      if (result.success && result.isAdmin) {
        // Redirect to admin dashboard
        navigate('/admin');
      } else {
        setError('Invalid admin credentials. Use admin@blueskyenergy.in / admin@123');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-header">
          <div className="admin-logo">
            <h1>Blue Sky Energy</h1>
            <h2>Admin Panel Login</h2>
          </div>
          <p className="admin-subtitle">Restricted Access - Administrators Only</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          {error && (
            <div className="admin-error">
              <span>⚠️</span> {error}
            </div>
          )}

          <div className="admin-form-group">
            <label htmlFor="admin-email">Admin Email</label>
            <input
              type="email"
              id="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="admin@blueskyenergy.in"
              className="admin-input"
              required
            />
          </div>

          <div className="admin-form-group">
            <label htmlFor="admin-password">Admin Password</label>
            <input
              type="password"
              id="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter admin password"
              className="admin-input"
              required
            />
          </div>

          <div className="admin-credentials-note">
            <p><strong>Default Admin Credentials:</strong></p>
            <p>Email: <code>admin@blueskyenergy.in</code></p>
            <p>Password: <code>admin@123</code></p>
          </div>

          <button
            type="submit"
            className="admin-login-btn"
            disabled={isLoading}
          >
            {isLoading ? 'Authenticating...' : 'Login to Admin Panel'}
          </button>

          <div className="admin-back-link">
            <button 
              type="button" 
              className="back-to-main"
              onClick={() => navigate('/login')}
            >
              ← Back to User Login
            </button>
          </div>
        </form>

        <div className="admin-login-footer">
          <p className="admin-security">
            🔒 Secure Admin Access • Activity Logged • Unauthorized access prohibited
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;